import React, { useState } from 'react'

//Components.
import AllVideosComponent from '../../../components/all-videos/AllVideosComponent';

//Dependencies.
import { store } from '../../../app/store';

//Images.
import hourglass from "../../../images/hourglass_image.png";

//Functions.
  //Slice.
  import { useSelector } from 'react-redux';
  //Callback.
  import { allVideos } from '../../../slices/allVideosSlice';
  
import './AllVideosPage.styles.css';
import { Container } from 'reactstrap';


const AllVideosPage = () => {
  const videos = useSelector(allVideos);
  const storeState = store.getState();
  
  if (Object.values(videos).length) {
    return <AllVideosComponent />
  } else if (storeState.allVideosSliceReducer.isLoading) {
    return (
      <Container style={{ justifyContent: 'center', display: 'flex' }}>
        <h1 className='text-danger'><em>Please wait while we load all images...</em></h1>
        <hr />
        <AllVideosComponent />
      </Container>
    )
  } else {
    return (
      <div>
        <h1 className='text-danger'>SORRY... THERE ARE NO VIDEOS.</h1>
        <h3>videosSliceReducer Loading status: { JSON.stringify(storeState.allVideosSliceReducer.isLoading) }.</h3>
        <h5>Please check back later.</h5>
      </div>
    )
  }
  
}

export default AllVideosPage